module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"moreActions":{"rename":"Rename","delete":"Delete","deactivate":"Deactivate","revertEdits":"Discard changes","share":"Share","copy":"Make a copy"}}}')
  delete Component.options._Ctor
}
